export default {
  balanceAndgoldenPocket: '钱包余额/财神通余额',
  enableGoldenPocket: '开启财神通',
  GoldenPocketStatus: '是否开通财神通状态',
  goldenPocket: '财神通余额',
  goldenPocketTotalBlance: '财神通总余额',
  GoldenPocketClose: '已关闭',
  GoldenPocketOpen: '已开启',
  NotGoldenPocket: '未开通',
  createMomoOrder: '创建MoMo提款单',
  createZaloOrder: '创建Zalo提款单',
  createVIETTELOrder: '创建VIETTEL提款单',
  home: '首页',
  login: '登录',
  register: '注册',
  logout: '退出登录',
  confirmLogout: '您确定退出登录？',
  username: '用户名',
  password: '密码',
  enterPassword: '请输入密码',
  submit: '提交',
  search: '查询',
  option: '操作',
  new: '新增',
  edit: '编辑',
  cancelEdit: '已恢复为原始值',
  delete: '删除',
  warning: '警告',
  week: '最近一周',
  mount1: '最近一个月',
  mount3: '最近三个月',
  to: '至',
  startDate: '开始日期',
  endDate: '结束日期',
  confirmDelete: '您确定删除此项目？',
  yes: '确定',
  cancel: '取消',
  success: '成功',
  fail: '失败',
  doActive: '激活',
  cancelActive: '取消激活',
  active: '已激活',
  normal: '正常',
  expired: '已过期',
  unActive: '未激活',
  init: '初始化',
  open: '打开',
  close: '关闭',
  online: '在线',
  outline: '离线',
  faceline: '需要CCCD认证',
  locked: '已锁定',
  serial: '设备号',
  enterSerial: '请输入设备号',
  amount: '金额',
  balance: '余额',
  desc: '描述',
  remark: '备注',
  name: '姓名',
  status: '状态',
  createDate: '创建时间',
  createBy: '创建人',
  updateDate: '更新时间',
  updateBy: '更新人',
  resend: '重新发送',
  reset: '重置',
  choose: '请选择',
  opened: '开启成功',
  closed: '关闭成功',
  pullBalance: '拉取余额',
  supplier: '运营商',
  placeholder: '请输入',
  bankInfo: '银行账号信息',
  trueName: '账号真实姓名',
  inBalance: '入款',
  outBalance: '出款',
  payment: '代付',
  cancelPayment: '取消代付',
  openPayment: '开启代付',
  BindingSession: '绑定Session',
  Binding: '绑定',

  homePage: {
    globalLang: '全球语言',
    fontSize: '字号',
    sizeDefault: '默认',
    sizeMedium: '中等',
    sizeSmall: '小',
    sizeMini: '最小'
  },
  changePwd: {
    title: '更改密码',
    confirmPwd: '确认密码',
    pwdPlaceholder: '请输入密码',
    pwdPlaceholderAgain: '请再次输入密码'
  },
  momo: {
    title: 'Momo账号',
    list: {
      title: '账号列表',
      phoneNo: '电话号码',
      receive: '收款状态',
      inline: '是否在线',
      noEdit: '电话号码已恢复为原始值',
      initSuccess: '初始化成功，是否注册该设备',
      registerSuccess: '注册成功，是否继续提交设备OTP',
      createSuccess: '创建设备成功，是否初始化设备',
      withdrawalLimit: '自动提款金额',
      fixedWithdrawalLimit: '固定提现额度',
      autoReceive: '自动提款',
      todayReceive: '当日收款',
      monthReceive: '当月收款',
      dayWithdrawnAmount: '当日提款金额',
      withdrawnAmount: '当月提款金额',
      withdrawalTotalFee: '已提款手续费',
      step1: '基本信息',
      step2: '初始化设备',
      step3: '注册设备',
      step4: '完成',
      otpTip: '请输入4位纯数字OTP码',
      vtpotpTip: '请输入4位纯数字OTP码',
      zaloOtpTip: '请输入6位纯数字OTP码',
      googleTip: '请输入6位纯数字Google验证码',
      session: '请输入纯数字OTP码',

      node: '* 请注意，如果您正在打开应用程序，请退出应用程序（均处于后台模式）。 点击“新建”后，请重新打开应用程序进行连接。',
      activeTip: '是否确定取消激活',
      unActiveTip: '是否确定激活',
      activeSuccess: '激活成功',
      unActiveSuccess: '取消激活成功',
      openReceiveTip: '您确认开启自动收款?',
      closeReceiveTip: '您确认关闭自动收款?',
      closeTip: '是否确定关闭自动代付',
      openTip: '是否确定开启自动代付',
      paymentSuccess: '已开启自动代付',
      paymentFail: '已关闭自动代付',
      payment: '是否代付'
    },
    onlineList: {
      title: '已激活列表'
    }
  },
  transaction: {
    title: 'Momo交易',
    createOrder: {
      title: '创建提款单',
      tkMomoAccount: '提款账户',
      toMomoAccount: '转入账户',
      tkMomoTip: '请选择一个提款账户',
      toMomoTip: '请输入收款账户',
      type: '提款类型',
      typeTip: '请选择一个提款类型',
      bank: '选择银行账户',
      bankTip: '请选择一个银行',
      tip: '提款到银行',
      withdrawAmount: '提款金额',
      amountTip: '请输入提款金额',
      amount50w: '外部转账金额不能低于两万',
      amount1w: '外部转账金额不能低于10000',
      amount100: '账户互转金额不能低于1000',
      node: '* 提交前请仔细核对信息',
      cancelTrans: '您取消了提款请求',
      transactionNo: '交易号',
      transactionContent: '收款消息',
      maxWithdrawal: '最大提款金额',
      calculationFormula: '计算公式'
    },
    receive: {
      title: 'LS收款',
      date: '时间',
      gdCode: '收款单',
      receiveAccount: '收款账户',
      depositAccount: '提款账户',
      receiveTime: '收款时间',
      scanTime: '扫描时间'
    },
    redpack: {
      openTime: '打开时间'
    },
    withdrawal: {
      title: 'LS提款',
      amountTotal: '总计(金额)',
      feeTotal: '总计(手续费)',
      date: '时间',
      gdCode: '提款单',
      depositAccount: '提款账户',
      receiveAccount: '收款账户',
      tkName: '转入账户姓名',
      cost: '手续费',
      total: '总金额',
      perAmount: '转账前余额',
      proAmount: '转账后余额',
      type: '类型',
      author: '操作人',
      optionTime: '操作时间',
      systemNo: '系统单号'
    }
  },
  bankManage: {
    title: 'Momo银行管理',
    addNew: {
      title: '新增银行卡',
      tkMomoTip: '请输入Momo账号',
      bankNumber: '银行卡号',
      accountNoTip: '请输入正确的账户号码',
      bank: '银行',
      bankTip: '请选择银行',
      tkNameTip: '姓名不能为空',
      bankName: '银行名称',
      bankNameTip: '银行名称不能为空',
      bankNameSort: '银行名称(别名)',
      bankCode: '银行代码',
      node: '* 提交前请仔细核对信息'
    },
    list: {
      title: '银行卡列表',
      tkMomo: 'Momo手机号',
      accountNo: '账户号码',
      bankName: '银行名称'
    }
  },
  administrator: {
    title: '管理员管理',
    addNew: {
      title: '新增管理员',
      account: '登录账号',
      password: '密码',
      confirmPwd: '确认密码',
      group: '角色',
      selectGroup: '选择角色',
      nameTip: '用户名不能为空',
      accountTip: '登录账号不能为空',
      phoneTip: '手机号不能为空',
      passwordTip: '密码不能为空',
      configPwdTip: '请再一次输入密码',
      groupTip: '请选择角色'
    },
    list: {
      title: '管理员列表',
      lastLoginTime: '最后登录时间'
    },
    ip: {
      title: 'IP管理',
      ipTip: '请输入IP地址',
      usernameTip: '请输入管理员账号'
    },
    logs: {
      title: '账号错误日志',
      serialNo: '编号',
      serialNumber: '设备号',
      errorMsg: '错误信息'
    }
  },
  roleManager: {
    title: '角色管理',
    roleName: '角色名称',
    role: {
      title: '新增角色',
      roleNameTip: '请输入角色名称',
      setting: '权限设置',
      reLogin: '修改成功，请重新登陆'
    },
    roleList: {
      title: '角色列表'
    },
    permission: {
      title: '权限管理'
    }
  },
  transactionTypes: {
    1: '内部账户转账',
    2: '向外部账户转账',
    7: '财神通',
    72: '财神通转绑定银行卡',
    73: '财神通转momo账号'
  },
  zalo: {
    list: {
      title: 'Zalo账号'
    },
    trans: {
      title: 'Zalo交易管理'
    },
    bank: {
      title: 'Zalo银行管理',
      phone: 'Zalo手机号',
      account: '账户号'
    }
  },
  vtp: {
    list: {
      title: 'VTP账号'
    },
    trans: {
      title: 'VTP交易管理'
    },
    bank: {
      title: 'VTP银行管理',
      phone: '手机号',
      account: '账户号'
    }
  },
  momoQr: {
    list: {
      title: 'MomoQR账号'
    },
    trans: {
      title: 'MomoQR交易管理'
    },
    bank: {
      title: 'MomoQR银行管理',
      phone: 'MomoQR手机号',
      account: '账户号'
    }
  },
  waiting: '请稍等，正在下载。。。。',
  up: '升序',
  down: '降序',
  disActive: '冻结',
  sortField: '排序字段',
  limitPlaceHolder: '请输入提款上限',
  needInput: '请输入有效数据',
  abRecords: {
    title: '异常收款记录'
  },
  lastAccept: '最后收款时间',
  sumBalance: '总余额',
  version: '版本号',
  paymentTime: '支付时间',
  orderNo: '缴费单号',
  paymentAccount: '缴费账号',
  paymentAccountType: '缴费账户类型',
  transId: '缴费交易号',
  paymentStatus: '缴费状态',
  paymentRemark: '备注信息',
  export: '导出',
  import: '导入',
  downloadTemplate: '下载模板',
  paymentSupplier: '付款供应商',
  paymentAmount: '付款金额',
  DateCreated: '创建时间',
  creator: '创建人',
  DateModified: '修改时间',
  modifier: '修改人',
  Upload: '上传',
  close: '关闭',
  confirm: '确认',
  state1: '等待支付',
  state2: '支付成功',
  state3: '已支付',
  state4: '支付失败',
  waiting: '等待中',
  downLoad: {
    a1: '请先下载模板文件',
    a2: '请上传模板文件',
    selectfile: '选择文件',
    ImportSuccess: '导入成功',
    Importfailed: '导入失败'
  },
  utilityStatus: '水电费状态',
  WalletBalance: '钱包余额'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/common.js